import axios from "axios";

export default function runAxiosSetup({ apiUrl, bearerToken, headers = {} }) {
  axios.defaults.baseURL = apiUrl;

  // Set default headers with Authorization in Bearer format
  axios.defaults.headers.common = {
    Accept: "application/json",
    Authorization: bearerToken ? `Bearer ${bearerToken}` : undefined, // ✅ Fixed format
    ...headers, 
  };

  // Clear previous interceptors before adding new ones
  axios.interceptors.response.handlers = [];
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      console.log("Axios Error:", error);
      const errorObject = {};

      if (error.response) {
        errorObject.message = error.response.data.message || "Server Error!!!";
        errorObject.code = error.response.data.code || "X_SERVER_ERROR";
        errorObject.type = error.response.status;
        errorObject.data = error.response.data;
      } else if (error.code === "ERR_NETWORK") {
        errorObject.message = "Network Error!!!";
        errorObject.code = "X_NETWORK_ERROR";
        errorObject.type = 0;
      } else {
        errorObject.message = "Unknown Error!!!";
        errorObject.code = "X_UNKNOWN_ERROR";
        errorObject.type = 0;
      }

      return Promise.reject(errorObject);
    }
  );
}
